import { connect } from 'react-redux';
import { FullState } from 'main/reducers';
import { StandardDispatch } from 'main/store';
import {
  ReadingsCountPanelProps,
  ReadingsCountPanelView,
} from './ReadingsCountPanelView';
import withInit, { InitProps } from 'components/hoc/withinit';
import { fetchReadingsCount } from 'ducks/readings/processingRequest/detail';

interface OwnProps {
  requestId: number;
}

type StateProps = ReadingsCountPanelProps;

const mapStateToProps = (state: FullState): StateProps => ({
  readingsCountData: state.reprocessingRequest.detail.readingsCountData,
  isLoading: state.reprocessingRequest.detail.isLoading,
  error: state.reprocessingRequest.detail.error,
});

const mapDispatchToProps = (
  dispatch: StandardDispatch,
  ownProps: OwnProps
) => ({
  onInit: () => dispatch(fetchReadingsCount(ownProps.requestId)),
});

export const ReadingsCountPanel = connect<
  StateProps,
  InitProps,
  OwnProps,
  FullState
>(
  mapStateToProps,
  mapDispatchToProps
)(withInit(ReadingsCountPanelView));
